module.exports = __webpack_public_path__ + "img/horizontal_6_4_pp1_6005.b7961de4.png";